import { getTranslate } from 'legacy-src/utilities/i18n'
import Markdown from 'markdown-to-jsx'
import React from 'react'

import LinkWithQueryForwarding from '../button/LinkWithQueryForwarding'
import Icon from '../icons/Icon'
import LockedBanner from '../premiumContent/LockedBanner'
import LessonTeaser from './LessonTeaser'
import { type AuthorType, type StrapiVideoLessonType } from './types'

type VideoLessonItemProps = {
  readonly lesson: StrapiVideoLessonType
  readonly author: AuthorType
  readonly isPreview?: boolean
  readonly isLocked?: boolean
  readonly className?: string
  readonly baseLink: string
}

const VideoLessonItem: React.FC<VideoLessonItemProps> = ({
  lesson,
  author,
  isPreview,
  isLocked,
  className,
  baseLink,
}) => {
  const { t } = getTranslate()

  const videoLesson = (
    <div className={`mb-2 flex w-full flex-col justify-between ${isLocked && 'opacity-40'}`}>
      <div>
        <LessonTeaser lesson={lesson} author={author} isLocked={isLocked} />
        <div className={`text-lg leading-6 ${isPreview ? 'line-clamp-5' : 'line-clamp-10'} `}>
          {lesson?.lessonInfo?.lessonContent && <Markdown>{lesson?.lessonInfo?.lessonContent}</Markdown>}
        </div>
      </div>
      <div className="flex justify-end">
        <div className="flex shrink items-center text-right">
          <div className="mr-3 text-base font-bold text-text-color">
            {t('component.premiumContent.lessonFooter.showFull')}
          </div>
          <Icon icon="arrow" size="md" color="primary" />
        </div>
      </div>
    </div>
  )
  if (!isPreview && isLocked) return <>{videoLesson}</>

  return (
    <LinkWithQueryForwarding
      href={isLocked ? baseLink : `${baseLink}/${lesson.slug}`}
      className={`${className} flex h-full self-stretch text-text-color hover:no-underline`}
    >
      {videoLesson}
    </LinkWithQueryForwarding>
  )
}

type Props = {
  readonly data: {
    readonly attributes?: StrapiVideoLessonType
  }[]
  readonly isPreview?: boolean
  readonly getItemClassName?: (item: any, index: number) => string
  readonly isLocked: boolean
  readonly baseLink: string
}

const VideoLessonsList: React.FC<Props> = ({ data, isPreview, getItemClassName, isLocked, baseLink }) => {
  const lessons = data

  return (
    <>
      {!isPreview && isLocked && <LockedBanner />}
      {lessons?.length > 0 && (
        <div className={'grid w-full grid-cols-1 gap-x-10 gap-y-8 tablet:grid-cols-2'}>
          {lessons.map((item, index) => {
            const lesson = item.attributes
            const author = lesson.lessonInfo?.lessonAuthor

            return (
              <VideoLessonItem
                className={getItemClassName && getItemClassName(item, index)}
                key={`videoLesson-${index}`}
                {...{ baseLink, isLocked, isPreview, author, lesson }}
              />
            )
          })}
        </div>
      )}
    </>
  )
}

export default VideoLessonsList
